import { defaultConfig } from 'tailwind-variants';

import styles from '../index.css?inline';

defaultConfig.twMerge = false;

export function extendWithStyles(
  svelteCustomElementClass: new () => HTMLElement,
): typeof svelteCustomElementClass {
  return class extends svelteCustomElementClass {
    constructor() {
      super();
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(styles);
      const shadowRoot = this.shadowRoot ?? this.attachShadow({ mode: 'closed' });
      shadowRoot.adoptedStyleSheets = [sheet];
    }
  };
}
